define([
	"csi",
	"csi/reflection",
	"csi/resolver",
	"csi/state/rootStore",
	"csi/store/Names",
	"csi/xml",
	"csi/xml/Search"
], function(csi, reflection, resolver, {routerStore}, Names, xml, Search) {

	// {String:Store}: map of all available product types by type
	var _typeStores = {},

		_getProductType = function(/*Node?*/product, /*String?*/idType) {
			product = product || routerStore.getBreadcrumbNode("Style") || routerStore.getBreadcrumbNode("Material") || routerStore.getBreadcrumbNode("Food");
			if (product && product.$Type === "Food") {
				idType = "Subtype";
			}
			return product ? product[idType || "ProductType"] : null;
		};

	return {
		getByUrl: function(/*String*/urlType, /*String?*/id) {
			var type = resolver.resolveNode(urlType, true);
			if (!type) return null;
			var c = resolver.resolveNode(type.ProductionConfig, true);
			return (c && id) ? c[id] : c;
		},

		getSubtypeUrlByName: function(/*String*/type, /*String*/name) {
			// summary: matching function in csi/config for StyleType and MaterialType
			// For this to work, the store must already be queried. So, if this is used in Site.js, make sure to
			// call ProductType.store("StyleType").query() at the top of the file.
			var store = this.store(type);
			if (store.isLoaded()) {
				var item = store.get(name);
				if (item) {
					return item[store.urlProperty];
				}

				console.error("ProductType.getSubtypeUrlByName - subtype with name '" + name + "' does not exist!");
			} else {
				console.error("ProductType.getSubtypeUrlByName - ProductType.store(" + type + ").query() must be called before using this function!");
			}
		},

		getTypeName: function(/*String*/urlType) {
			var type = resolver.resolveNode(urlType, true);
			if (!type) return null;
			return type.$Name;
		},

		get: function(/*Node?*/product, /*String?*/id) {
			var url = _getProductType(product);
			return url ? this.getByUrl(url, id) : null;
		},

		hasColor: function(/*Node?*/product) {
			return this.get(product, "HasColor");
		},

		hasSize: function(/*Node?*/product) {
			return this.get(product, "HasSize");
		},

		isSizeOwner: function(/*Node?*/product) {
			return this.get(product, "IsSizeOwner");
		},

		hasDim: function(/*Node?*/product) {
			var c = this.get(product);
			return c ? (c.HasColor || c.HasSize) : false;
		},

		hasTDS: function(/*Node?*/product, /*String?*/tds) {
			// summary: determine tab visibility for data sheet based on material type
			if (tds && !reflection.getClass(tds)) return false;

			var obj = this.get(product, "TDSMap");
			if (!obj) return false;

			return tds ? obj[tds] : csi.objectHasValue(obj, true);
		},

		/**
		 * Check if we enable FDD on this product
		 * @param {C8Node} product
		 */
		isFDDProduct(product) {
			const level = this.get(product, "ProductSourceCreationLevel");
			return "ProductSourceCreationLevel:Factory" === level;
		},

		/**
		 * get the actual setting of the product type
		 * @param {String} urlType
		 * @param {String} setting
		 * @return {Node}
		 */
		getTypeSetting: function(urlType, setting) {
			var node = this.getByUrl(urlType);
			return node ? node[setting] : null;
		},

		/**
		 * get the actual attribute of the TDS Mapping
		 * @param {String} urlType
		 * @param {String} typeTDS the actual attribute
		 * @return {C8Node}
		 */
		getTypeTDSSetting: function(urlType, typeTDS) {
			var tdsMap = this.getTypeSetting(urlType, "TDSMap");
			return tdsMap && tdsMap[typeTDS];
		},

		name: function(/*Node?*/product, /*String?*/idType) {
			// summary: return name of product type for given product
			var url = _getProductType(product, idType);
			var node = url ? resolver.resolveNode(url, true) : null;
			return node ? node.$Name : null;
		},

		type: function(/*Node?*/product, /*String?*/idType) {
			// summary: return type of product type for given product
			var url = _getProductType(product, idType);
			var node = url ? resolver.resolveNode(url, true) : null;
			return url ? node.$Type : null;
		},

		store: function(/*String*/type) {
			// summary: return store for given type
			if (!_typeStores[type]) {
				var s = new Search();
				s.byType(type);
				s.getQuery().Attr("Available", xml.OP_EQUALS, true, "Child:ProductionConfig");

				_typeStores[type] = new Names({
					request: s.getRequest(),
					idProperty: "Name",
					typeNode: type,
				});
			}

			return _typeStores[type];
		},

		/**
		 * Apply style hierarchy filters
		 * @param {Node} style
		 * @param {Query} query
		 * @param {Cache} cache
		 * @param {String} [path] If the filter is applied for ColorInPalette nodes, then path will be set to it's parent
		 */
		applyStyleHierarchyFilters(style, query, cache, path) {
			const {Category1, Category2, Collection, ParentSeason} = style;
			query.Or()
				.RefAttr("Seasons", xml.OP_EQUALS, ParentSeason, path)
				.Attr2("Seasons", xml.OP_EQUALS, {Dimension: 0, Path: path});
			query.Or()
				.Attr("Category1Names", xml.OP_EQUALS, cache.get(Category1).$Name, path)
				.Attr2("Category1Names", xml.OP_EMPTY_STRING, {Path: path});
			query.Or()
				.Attr("Category2Names", xml.OP_EQUALS, cache.get(Category2).$Name, path)
				.Attr2("Category2Names", xml.OP_EMPTY_STRING, {Path: path});
			query.Or()
				.Attr("CollectionNames", xml.OP_EQUALS, cache.get(Collection).$Name, path)
				.Attr2("CollectionNames", xml.OP_EMPTY_STRING, {Path: path});
		},

		/**
		 * Check if the color rule is enforced for the ProductType
		 * @param {Node} product
		 * @return {String}
		 */
		getColorRule(product) {
			return this.get(product, "ColorPaletteRule");
		}
	};
});